import { Radio } from "antd";
import { useTranslation } from "react-i18next";
import { ROLE_SCOPES, type RoleScope } from "../types";
import { ScopeIcon } from "./roleVisuals";

interface ScopeCardsProps {
	/** Antd `Form.Item` bu proplarni o'zi uzatadi. */
	id?: string;
	value?: RoleScope;
	onChange?: (value: RoleScope) => void;
	disabled?: boolean;
}

const CARD_BASE =
	"!m-0 !flex w-full !items-start rounded-lg border px-3.5 py-3 transition-colors [&_.ant-radio]:!mt-[3px] [&_.ant-radio]:!self-start";
const CARD_ON = "border-[#1c5cab] bg-[#f4f8fd] dark:border-[#6fa3e6] dark:bg-[#18222f]";
const CARD_OFF =
	"border-[#e5e6e3] bg-white hover:border-[#1c5cab] dark:border-[#2a2e33] dark:bg-[#181b1f] dark:hover:border-[#6fa3e6]";

/**
 * Rol doirasi — uchta karta. ⚠️ Ichida antd `Radio.Group` QOLADI: klaviatura
 * navigatsiyasi va `input[type=radio][value=…]` (testlar shu selektorga
 * tayanadi) tekin keladi. Doira majburiy — `resolveScopeFromRoles` noma'lum
 * qiymatni jimgina `self` deb olardi (CLAUDE.md «Auth modeli»).
 */
export function ScopeCards({ id, value, onChange, disabled = false }: ScopeCardsProps) {
	const { t } = useTranslation("roles");

	return (
		<Radio.Group
			id={id}
			value={value}
			disabled={disabled}
			onChange={(event) => onChange?.(event.target.value as RoleScope)}
			className="!block w-full"
		>
			<div className="grid grid-cols-1 gap-3 md:grid-cols-3">
				{ROLE_SCOPES.map((scope) => (
					<Radio
						key={scope}
						value={scope}
						className={`${CARD_BASE} ${value === scope ? CARD_ON : CARD_OFF}`}
					>
						<span className="flex flex-col gap-1.5">
							<span className="flex items-center gap-2 font-medium">
								<ScopeIcon
									scope={scope}
									className={
										value === scope && !disabled
											? "text-[#1c5cab] dark:text-[#8fb6ea]"
											: "text-[#8a929e]"
									}
								/>
								{t(`scope.${scope}`)}
							</span>
							<span className="text-xs leading-normal text-[#565e6b] dark:text-[#a3aab5]">
								{t(`scopeHint.${scope}`)}
							</span>
						</span>
					</Radio>
				))}
			</div>
		</Radio.Group>
	);
}
